import jquery from 'jquery';

window.jQuery = jquery;
window.$ = jquery;

export function start() {
    return new Promise((resolve) => {
        jquery(function () {
            resolve();
        });
    });
}


// WEBPACK FOOTER //
// ./Statics/scripts/Core/App.js